import { z } from 'zod';
import { email, uuid } from './common.js';
import { weakPasswordReason } from '../passwords.js';
/** ASVS L2 V2.1: 12-128 characters, no composition rules, common passwords refused. */
export const newPassword = z
    .string()
    .min(12)
    .max(128)
    .superRefine((value, ctx) => {
    const reason = weakPasswordReason(value);
    if (reason)
        ctx.addIssue({ code: 'custom', message: reason });
});
export const loginRequest = z.object({
    email,
    password: z.string().min(1).max(128),
});
export const totpCode = z.string().regex(/^\d{6}$/, 'Enter the 6-digit code');
export const mfaVerifyRequest = z
    .object({
    code: totpCode.optional(),
    recoveryCode: z.string().trim().min(8).max(32).optional(),
})
    .refine((v) => Boolean(v.code) !== Boolean(v.recoveryCode), {
    message: 'Provide either code or recoveryCode',
});
export const mfaEnrollConfirmRequest = z.object({ code: totpCode });
export const refreshRequest = z.object({ refreshToken: z.string().min(20).max(200).optional() });
export const changePasswordRequest = z.object({
    currentPassword: z.string().min(1).max(128),
    newPassword,
});
export const deviceEnrollRequest = z.object({
    deviceId: uuid,
    enrollmentCode: z.string().trim().min(8).max(64),
});
export const deviceLoginRequest = z.object({
    deviceId: uuid,
    deviceSecret: z.string().min(32).max(128),
    badgeNo: z.string().trim().min(1).max(32),
    pin: z.string().regex(/^\d{4,6}$/),
});
//# sourceMappingURL=auth.js.map